import Controller from 'controllers/controller';
import Elements from 'tools/elements';

class NavController extends Controller {
    ready() {
        this.elements = new Elements();

        this.options = {
            mouseLeaveDuration : 400,
            mouseEnterDuration : 200
        };

        this.cacheElements();
        this.attachEvents();
        this.onWindowResize();
    }

    cacheElements() {
        this.elements.queryOne('desktopNav', '#header .bottom');
        this.elements.queryOne('desktopNavTopLevelList', '#header .top-level-list');
        this.elements.queryAll('desktopNavLi', '#header .bottom ul > li.dropdown');
        this.elements.queryAll('desktopNavLiSub', '#header .bottom ul > li.dropdown > ul > li.dropdown');
    }

    attachEvents() {
        window.addEventListener('resize', this.onWindowResize, {passive: true});

        let liCount = this.elements.desktopNavLi.length,
            iter;

        for(iter = 0; iter < liCount; ++iter) {
            this.elements.desktopNavLi[iter].addEventListener('mouseenter', this.onMouseEnterLi);
            this.elements.desktopNavLi[iter].addEventListener('mouseleave', this.onMouseLeaveLi);
        }

        liCount = this.elements.desktopNavLiSub.length;

        for(iter = 0; iter < liCount; ++iter) {
            this.elements.desktopNavLiSub[iter].addEventListener('mouseenter', this.onMouseEnterLiSub);
            this.elements.desktopNavLiSub[iter].addEventListener('mouseleave', this.onMouseLeaveLiSub);

        }

        /**
         * Since we have a custom font, the size of the active menu item changes when it loads, so we need to reposition
         * the arrow when that time comes.
         */
        if(typeof document.fonts === 'object') document.fonts.onloadingdone = this.onWindowResize;

        // Hacky fallback that doesn't involve polyfills, but works
        else setTimeout(this.onWindowResize, 1000) && setTimeout(this.onWindowResize, 2500);
    }

    onWindowResize() {
        let windowWidth = document.body.offsetWidth;

        this.elements.each('desktopNavLi', it => {
            let item = it,
                childUl,
                arrow;

            if(!item.hasOwnProperty('cachedChildUl')) {
                item.cachedChildUl = item.querySelector('ul');
            }

            if(!item.hasOwnProperty('cachedArrowElement')) {
                item.cachedArrowElement = item.querySelector('.arrow');
            }

            childUl = item.cachedChildUl;
            arrow = item.cachedArrowElement;

            // If there is no child UL element
            if(!childUl) {
                return;
            }

            item.classList.add('displayed');

            let liWidth = item.offsetWidth,
                ulWidth = childUl.offsetWidth,
                liLeft = item.offsetLeft,
                newUlLeft = (liWidth / 2) - (ulWidth / 2),
                arrowWidth = arrow.offsetWidth,
                newArrowLeft = (ulWidth / 2) - (arrowWidth / 2);

            // If UL element overflows the window boundries, then right align it
            if((liLeft - newUlLeft) + ulWidth > windowWidth || liLeft - newUlLeft < 0) {
                let oldNewUlLeft = newUlLeft,
                    widthDiff;

                if(liLeft - newUlLeft < 0) {
                    newUlLeft = liLeft;
                } else {
                    newUlLeft = ulWidth - liWidth;
                }

                widthDiff = newUlLeft - oldNewUlLeft;
                // Add difference to arrowLeft so it is always centred.
                newArrowLeft += widthDiff;
            }

            childUl.style.left = newUlLeft + 'px';
            arrow.style.left = newArrowLeft + 'px';

            item.classList.remove('displayed');
        });
    }

    onMouseEnterLi(event) {
        let li = event.currentTarget,
            liCount = this.elements.desktopNavLi.length,
            iter,
            liActive = false;

        for(iter = 0; iter < liCount; ++iter) {
            let cLi = this.elements.desktopNavLi[iter];

            // Current element cannot count
            if(cLi.classList.contains('displayed')) {
                liActive = true;
            }

            if(cLi === li) {
                continue;
            }

            cLi.classList.remove('displayed');
        }

        if(li.mouseLeaveTimeout !== null) {
            clearTimeout(li.mouseLeaveTimeout);
        }

        // If we're coming from one LI to another, don't delay.
        if(liActive) {
            li.classList.add('displayed');
        } else {
            li.mouseEnterTimeout = setTimeout(function() {
                li.classList.add('displayed');
            }, this.options.mouseEnterDuration);
        }
    }

    onMouseLeaveLi(event) {
        let li = event.currentTarget;

        if(li.mouseEnterTimeout !== null) {
            clearTimeout(li.mouseEnterTimeout);
        }

        li.mouseLeaveTimeout = setTimeout(function() {
            li.classList.remove('displayed');
        }, this.options.mouseLeaveDuration);
    }

    onMouseLeaveLiSub(event) {
        let li = event.currentTarget;

        if(li.mouseEnterTimeout !== null) {
            clearTimeout(li.mouseEnterTimeout);
        }

        li.mouseLeaveTimeout = setTimeout(function() {
            li.classList.remove('displayed');
        }, this.options.mouseLeaveDuration);
    }

    onMouseEnterLiSub(event) {
        let li = event.currentTarget,
            liCount = this.elements.desktopNavLiSub.length,
            iter,
            liActive = false;

        for(iter = 0; iter < liCount; ++iter) {
            let cLi = this.elements.desktopNavLiSub[iter];

            // Current element cannot count
            if(cLi.classList.contains('displayed')) {
                liActive = true;
            }

            if(cLi === li) {
                continue;
            }

            cLi.classList.remove('displayed');
        }

        if(li.mouseLeaveTimeout !== null) {
            clearTimeout(li.mouseLeaveTimeout);
        }

        // If we're coming from one LI to another, don't delay.
        if(liActive) {
            li.classList.add('displayed');
        } else {
            li.mouseEnterTimeout = setTimeout(function() {
                li.classList.add('displayed');
            }, this.options.mouseEnterDuration);
        }
    }
}

export default NavController;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/controllers/nav.js